
import { Dialog } from 'primereact/dialog';
import { ProgressSpinner } from 'primereact/progressspinner';
import React, { useEffect, useState, useRef } from 'react';



export interface ProgressDialogProps {
    open: boolean;
}

export function ProgressDialog(props: ProgressDialogProps) {

    const [_dialogOpen, setDialogOpen] = useState<boolean>(false);

    useEffect(() => {
        setDialogOpen(props.open)
    }, [props.open])

    return (
        <Dialog id="progress-dialog" className="fabrix-progress-dialog" contentClassName='fabrix-progress-dialog-content' 
        showHeader={false} closeOnEscape={false} visible={_dialogOpen} onHide={() => setDialogOpen(false)}>
            <div className="progress-box"  >
                <ProgressSpinner strokeWidth='3px' className='fabrix-progress-dialog-spinner'>
                </ProgressSpinner>
            </div>
        </Dialog>
    )
}